import { lazy } from "react";

export const Login = lazy(() => import("./login"));
export const M2CDashboard = lazy(() => import("./m2c-dashbaord"));
export const AthleticsDashboard = lazy(() => import("./athletics-dashbaord"));
export const History = lazy(() => import("./history"));
export const SimulationHistory = lazy(() => import("./baseball-history"));
export const LaunchDashboard = lazy(() => import("./launch-dashboard"));
export const Statistics = lazy(() => import("./statistics"));
export const Settings = lazy(() => import("./settings"));
export const SetPassword = lazy(() => import("./set-password"));
export const M2cSimulation = lazy(() => import("./m2c-simulation"));
export const ForgotPassword = lazy(() => import("./forgot-password"));
export const OTPVarification = lazy(() => import("./otp-varification"));
export const Results = lazy(() => import("./results"));
export const M2CDashboardSandbox = lazy(
  () => import("./m2c-golf-sandbox-dashboard")
);

export const SupportTickets = lazy(() => import("./support-tickets"));
export const SupportTicketDetail = lazy(
  () => import("./support-ticket-detail")
);

export const StudioDashboard = lazy(() => import("./studioDashboard"));
export const GolfFacilityDetail = lazy(() => import("./golf-facility-detail"));

export const PerFormanceGolfHistory = lazy(() =>
  import("./pg-history").then((module) => ({
    default: module.PerFormanceGolfHistory,
  }))
);
// export * from "./login";
// export * from "./m2c-dashbaord";
// export * from "./athletics-dashbaord";
// export * from "./history";
// export * from "./launch-dashboard";
// export * from "./statistics";
// export * from "./settings";
// export * from "./set-password";
// export * from "./m2c-simulation";
// export * from "./forgot-password";
// export * from "./login";
// export * from "./otp-varification";
// export * from "./results";
// export * from "./m2c-golf-sandbox-dashboard";
